import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './YourInformation.module.scss'
import { masterNumberAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const MasterNumber = ({ t, validateMasterNumber, masterNumberError, masterNumberValid, caseNumberJEINError, setIsError, isDisabled }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const masterNumber = useSelector((state) => state.app.masterNumber)

  const handleMasterNumber = (e) => {
    try {
      let number = e.currentTarget.value.toUpperCase()
      dispatch(masterNumberAction(number))
      // validateMasterNumber(number)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  // const onBlurMasterNumber = (e) => {
  //   try {
  //     let number = e.currentTarget.value.trim()
  //     SetIsFocussed(false)
  //     dispatch(masterNumberAction(number))
  //     validateMasterNumber(number)
  //   } catch (err) {
  //     console.log(err)
  //     setIsError(true)
  //   }
  // }

  const onBlurMasterNumber = (e) => {
    try {
      SetIsFocussed(false)
      let element = e.currentTarget.value.toUpperCase()
      if (RegExp(/^[a-zA-Z0-9 ]{10,14}$/i).test(element) && RegExp(/^[a-zA-Z]*$/i).test(element[0])) {
        let lastName = '',
          datePosition = 0
        for (let i = 0; i < 5; i++) {
          if (isNaN(element[i])) {
            datePosition++
          }
          if (element[i] === ' ') {
            lastName = lastName + ' '
          } else {
            lastName = isNaN(element[i]) ? lastName + element[i] : lastName + ' '
          }
        }
        lastName = lastName + element.substring(datePosition).trim()
        dispatch(masterNumberAction(lastName.trim().toUpperCase()))
        validateMasterNumber(lastName.trim().toUpperCase())
      } else {
        dispatch(masterNumberAction(element.trim().toUpperCase()))
        validateMasterNumber(element.trim().toUpperCase())
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <React.Fragment>
      <div className={styles['fields_margin']}>
        <div
          className={
            masterNumberValid === true
              ? masterNumber !== '' && 'form-group has-success'
              : masterNumberValid === false && 'form-group ns-form-group-message-error'
          }
        >
          <label className="control-label" htmlFor="MasterNumber">
            <b>{t('your_information.master_number')}</b>
          </label>
          <div className="help-field">{t('your_information.master_number_prompt')}</div>
          {masterNumberValid === false && (
            <div className="ns-form-error-container has-error error-msg-align">
              <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
              <div className={isFocussed ? 'help-block-focused' : 'help-block'}>
                <span>{caseNumberJEINError ? caseNumberJEINError : t(masterNumberError)}</span>
              </div>
            </div>
          )}
          <input
            autoFocus
            style={{ width: '300px' }}
            type="text"
            id="MasterNumber"
            className={['form-control', styles['field_width_12_rem']].join(' ')}
            value={masterNumber.toUpperCase()}
            onChange={handleMasterNumber}
            //onBlur={onBlurMasterNumber}
            onFocus={() => SetIsFocussed(true)}
            autoComplete="off"
            maxLength="14"
            disabled={isDisabled}
          />
          {masterNumberValid === true && masterNumber !== '' && (
            <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(MasterNumber)
